import {IconDefinition} from '@fortawesome/fontawesome-svg-core';
import classNames from 'classnames';
import React from 'react';
import {WebSocketStatus} from '../types';
import Icon, {ICONS} from './Icon';

const STATUSES: Record<WebSocketStatus, {icon: IconDefinition, className: string}> = {
    [WebSocketStatus.Conntected]: {icon: ICONS.CONNECTED, className: 'text-success'},
    [WebSocketStatus.Connecting]: {icon: ICONS.CONNECTING, className: 'text-warning'},
    [WebSocketStatus.Disconnected]: {icon: ICONS.DISCONNECTED, className: 'text-danger'},
};

type Props = {
    status: WebSocketStatus;
};

const ConnectionStatus: React.FC<Props> = ({status}) => (
    <span title={status} className={classNames('ms-1', STATUSES[status].className)}><Icon icon={STATUSES[status].icon} /></span>
);

export default ConnectionStatus;
